/* =====================================================================
   PB CORE — PBCards' motor (v0.1). Alle andre PB-moduler bygger på den.
   PB.cfg · PB.on/emit · PB.get (cache) · PB.money · PB.toast · PB.idle
   + header-højde som CSS-variabel + intent-prefetch (browsere uden Speculation Rules).
   Debug: ?pbdebug i URL'en → fart-tal i konsollen.
   ===================================================================== */
(function () {
  'use strict';
  if (window.PB && window.PB.core) return;
  var w = window, d = document;
  var PB = w.PB = w.PB || {};
  PB.core = '0.1';
  PB.cfg = w.PB_CFG || {};
  /* Shopifys t-filter HTML-escaper teksterne (You're → You&#39;re): afkodes én gang her, så de kan sættes med textContent —
     og med PB.esc, når de bygges ind i HTML */
  (function (T) { if (!T) return; var x = d.createElement('textarea'); for (var k in T) if (typeof T[k] === 'string' && T[k].indexOf('&') > -1) { x.innerHTML = T[k]; T[k] = x.value; } })(PB.cfg.t);
  PB.t = function (k) { return (PB.cfg.t && PB.cfg.t[k]) || k; };

  /* event-bus */
  var ev = {};
  PB.on = function (n, f) { (ev[n] = ev[n] || []).push(f); return function () { PB.off(n, f); }; };
  PB.off = function (n, f) { if (ev[n]) ev[n] = ev[n].filter(function (x) { return x !== f; }); };
  PB.emit = function (n, x) {
    (ev[n] || []).slice().forEach(function (f) { try { f(x); } catch (e) { console.error('[PB]', n, e); } });
    try { d.dispatchEvent(new CustomEvent('pb:' + n, { detail: x })); } catch (e) {}
  };

  PB.idle = function (f, t) {
    if (w.requestIdleCallback) return w.requestIdleCallback(f, { timeout: t || 2000 });
    return setTimeout(f, 200);
  };

  /* fetch med cache (dedupe + TTL) */
  var mem = new Map();
  PB.get = function (url, opt) {
    opt = opt || {};
    var ttl = opt.ttl == null ? 60000 : opt.ttl, key = (opt.json ? 'j:' : 't:') + url, hit = mem.get(key);
    if (hit && Date.now() - hit.t < ttl) return hit.p;
    var p = fetch(url, { credentials: 'same-origin', headers: opt.headers || {} }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return opt.json ? r.json() : r.text();
    });
    mem.set(key, { t: Date.now(), p: p });
    p.catch(function () { mem.delete(key); });
    return p;
  };
  PB.bust = function (part) { mem.forEach(function (v, k) { if (!part || k.indexOf(part) > -1) mem.delete(k); }); };

  /* x,95 lige over (eller lig) et beløb i øre: 109,20 → 109,95 · 17,88 → 17,95 */
  PB.up95 = function (c) { var m = Math.floor((c - 95) / 100) * 100 + 95; return m < c ? m + 100 : m; };
  /* MEDLEMSPRIS pr. stk. (øre): normalprisen minus medlemsrabatten, rundet OP til nærmeste x,95 — aldrig mere rabat end
     procenten; sparer medlemmet ikke mindst 1 kr (afrundingen æder rabatten på billige varer), er svaret normalprisen
     (= ingen medlemspris). Samme regel som kassen (pb-tools · member-core.js) og snippets/pb-mprice.liquid — kun heltal,
     så alle tre får præcis samme tal. */
  PB.mUnit = function (cents, pct) {
    cents = Math.round(Number(cents) || 0);
    var h = Math.round((Number(pct) || 0) * 100);
    if (!(cents > 0) || !(h > 0)) return cents;
    var m = PB.up95(Math.floor((cents * (10000 - h) + 5000) / 10000));
    return cents - m >= 100 ? m : cents;
  };
  /* MEDLEMSPRIS + MÆNGDERABAT pr. stk. (øre): mængderabatten (p %) regnes af medlemsprisen mu og rundes op til x,95
     (109,95 − 3 % = 106,66 → 106,95). Giver det ikke mindst 1 kr mere end medlemsprisen, er svaret mu. Samme regel som
     kassen (pb-tools · member-core.js · memberQtyUnit) og snippets/pb-qd-box.liquid */
  PB.mqUnit = function (mu, p) {
    var r = PB.up95(mu - Math.floor(mu * Math.round((Number(p) || 0) * 100) / 10000));
    return mu - r >= 100 ? r : mu;
  };

  /* penge i butikkens eget format (samme som Liquid's | money) */
  PB.money = function (cents, fmt) {
    fmt = fmt || PB.cfg.moneyFormat || '{{amount}}';
    cents = Math.round(Number(cents) || 0);
    function f(n, dec, th, dp) {
      th = th == null ? ',' : th; dp = dp == null ? '.' : dp;
      var s = (n / 100).toFixed(dec).split('.');
      return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (s[1] ? dp + s[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return f(cents, 2);
        case 'amount_no_decimals': return f(cents, 0);
        case 'amount_with_comma_separator': return f(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return f(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return f(cents, 2, "'", '.');
        case 'amount_with_space_separator': return f(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return f(cents, 0, ' ', ',');
        default: return f(cents, 2);
      }
    });
  };

  PB.esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* beskeder nederst på skærmen */
  PB.toast = function (msg, err) {
    var box = d.querySelector('[data-pb-toasts]'); if (!box) return;
    var el = d.createElement('div'); el.className = 'pb-toast' + (err ? ' is-err' : ''); el.textContent = msg;
    box.appendChild(el);
    setTimeout(function () { el.style.transition = 'opacity .2s'; el.style.opacity = '0'; setTimeout(function () { el.remove(); }, 220); }, err ? 4200 : 2200);
  };

  /* header-højde → CSS-variabel (bruges af sticky filtre, galleri, mobilmenu) */
  function headerVars() {
    var h = d.querySelector('[data-pb-header]'); if (!h) return;
    var r = h.getBoundingClientRect();
    d.documentElement.style.setProperty('--pb-header-h', Math.round(h.offsetHeight) + 'px');
    var bar = h.querySelector('.pb-header__bar');
    if (bar) d.documentElement.style.setProperty('--pb-mnav-top', Math.round(bar.getBoundingClientRect().bottom + 8) + 'px');
  }
  PB.headerVars = headerVars;
  function onReady(f) { if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', f); else f(); }
  PB.ready = onReady;
  onReady(function () {
    headerVars();
    if (w.ResizeObserver) { var h = d.querySelector('[data-pb-header]'); if (h) new ResizeObserver(headerVars).observe(h); }
    w.addEventListener('scroll', function () { if (d.documentElement.classList.contains('pb-lock')) return; headerVars(); }, { passive: true });
  });

  /* scroll-lås til paneler */
  var locks = 0;
  PB.lock = function (on) {
    locks = Math.max(0, locks + (on ? 1 : -1));
    d.documentElement.classList.toggle('pb-lock', locks > 0);
    d.documentElement.style.overflow = locks > 0 ? 'hidden' : '';
  };

  /* intent-prefetch — kun hvor Speculation Rules mangler (Safari/Firefox) */
  var SPEC = !!(w.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'));
  var BAD = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkouts?|account|apps|discount|localization|services|password|challenge)(?:\/|$)/i;
  var seen = new Set();
  function linkURL(a) {
    if (!a || !a.href || a.target === '_blank' || a.hasAttribute('download') || a.closest('.no-prefetch')) return null;
    var u; try { u = new URL(a.href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin || !/^https?:$/.test(u.protocol)) return null;
    if (u.pathname === location.pathname && u.search === location.search) return null;
    if (BAD.test(u.pathname)) return null;
    return u;
  }
  function prefetch(u) {
    var k = u.pathname + u.search; if (seen.has(k) || seen.size > 40) return; seen.add(k);
    var l = d.createElement('link'); l.rel = 'prefetch'; l.href = u.href; l.as = 'document'; d.head.appendChild(l);
  }
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  if (!SPEC && !saveData) {
    var tmr = null;
    d.addEventListener('mouseover', function (e) { var a = e.target.closest && e.target.closest('a[href]'), u = linkURL(a); if (!u) return; clearTimeout(tmr); tmr = setTimeout(function () { prefetch(u); }, 65); }, { passive: true });
    d.addEventListener('mouseout', function () { clearTimeout(tmr); }, { passive: true });
    d.addEventListener('touchstart', function (e) { var a = e.target.closest && e.target.closest('a[href]'), u = linkURL(a); if (u) prefetch(u); }, { passive: true, capture: true });
  }
  PB.spec = SPEC;

  if (/[?&]pbdebug/.test(location.search)) {
    try {
      new PerformanceObserver(function (l) { var e = l.getEntries(), x = e[e.length - 1]; console.log('[PB] LCP', Math.round(x.startTime) + 'ms', x.element); }).observe({ type: 'largest-contentful-paint', buffered: true });
      w.addEventListener('load', function () { var n = performance.getEntriesByType('navigation')[0] || {}; console.log('[PB] TTFB', Math.round(n.responseStart) + 'ms | DOM', Math.round(n.domContentLoadedEventEnd) + 'ms | load', Math.round(n.loadEventEnd || performance.now()) + 'ms | levering:', n.deliveryType || 'netværk'); });
    } catch (e) {}
  }
  PB.emit('core');
})();
